import { createSharedPathnamesNavigation } from 'next-intl/navigation'

import { availableLocales, localePrefix } from '@/lib/i18n/config'

// These constants should be used throughout the application instead of their core next.js counterparts.
export const { Link, redirect, usePathname, useRouter } = createSharedPathnamesNavigation({
  locales: availableLocales,
  localePrefix
})
